import React, { useState } from "react";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

function Accordion({ title, children, defaultExpanded = false, icon = null }) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="accordion-container">
      <div className="accordion-header" onClick={toggleExpanded}>
        <div className="accordion-title-container">
          {icon && <div className="accordion-icon">{icon}</div>}
          <h4 className="accordion-title">{title}</h4>
        </div>
        <IconButton size="small" className="accordion-toggle-btn">
          {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </div>
      {isExpanded && (
        <div className="accordion-content">
          <div className="accordion-content-inner">{children}</div>
        </div>
      )}
    </div>
  );
}

Accordion.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  defaultExpanded: PropTypes.bool,
  icon: PropTypes.node,
};

export default Accordion;
